import React from 'react';

import { faEdit } from '~components/icon';
import { buildColumn, EditableColumnConfig } from '~components/table-view';

import ServiceColourBadge from './ServiceColourBadge';

const columnsFactory = (setSelectedService: (service: any) => void, setSelectedColour: (colour: string) => void) => {
  const columnsList: EditableColumnConfig[] = [
    {
      id: 'name',
      header: 'Service Name',
      type: 'link',
      props: {
        meta: {
          onClick: (original: any) => {
            const { id, name, colour } = original;
            setSelectedService({
              value: id,
              label: name,
              colour,
            });
            setSelectedColour(`${colour}`);
          },
          hoverIcon: faEdit,
        },
      },
    },
    {
      id: 'colour',
      header: 'Colour',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_isEditing = false, row: any): React.ReactElement | null => {
            return React.createElement(ServiceColourBadge, { rowData: row });
          },
        },
      },
    },
  ];
  return columnsList.map(buildColumn);
};

export default columnsFactory;
